import classNames from 'classnames';
import { useMemo, useState } from 'react';
import styles from './index.module.scss';
import { i18nText } from './i18nText';
import { i18nMap } from '@/constants/i18n';
import gtm from '@/utils/gtm';
import { useGlobal } from '@/utils/useGlobal';
import moment from 'moment';
import { sendMultiEmarsysEmail } from '@elem/ui/ef-emarsys-email/apis';
import { useRouter } from 'next/router';

export enum PAGE_TYPE {
    OutdoorRecreation = 'OutdoorRecreation',
    RoadTrips = 'RoadTrips',
    HomeBackup = 'HomeBackup',
    BatteryBackupForHome = 'BatteryBackupForHome',
    PowerIndependence = 'PowerIndependence',
    LoadShedding = 'LoadShedding',
    HomeBattery = 'HomeBattery',
    Vanlife = 'Vanlife',
    Camp = 'Camp',
    CostSaving = 'CostSaving',
    OffGrid = 'OffGrid',
    Save = 'Save',
}

interface Params {
    locale: string;
    className?: string;
    pageType: PAGE_TYPE;
    entry_position?: number | string;
}

const Icon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <g clipPath="url(#clip0_46_642)">
            <path
                d="M6.14966 3L6.46258 7.78185H7.53742L7.85034 3H6.14966ZM6.9932 8.94459C6.72109 8.94459 6.4898 9.0285 6.29932 9.22431C6.09524 9.40613 6 9.64389 6 9.9376C6 10.2173 6.09524 10.4551 6.29932 10.6509C6.4898 10.8467 6.72109 10.9446 6.9932 10.9446C7.26531 10.9446 7.5102 10.8467 7.71429 10.6649C7.90476 10.4691 8 10.2313 8 9.9376C8 9.64389 7.90476 9.40613 7.71429 9.22431C7.52381 9.0285 7.27891 8.94459 6.9932 8.94459Z"
                fill="#FA4500"
            />
            <path
                d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
                stroke="#FA4500"
            />
        </g>
        <defs>
            <clipPath id="clip0_46_642">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const EmailSubscribe = ({ locale, className = '', pageType, entry_position }: Params) => {
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const date = moment(systemTime).format('YYYY-MM-DD') as any;
    const { pathname } = useRouter();

    const EMAIL_SUB_DATA: any = {
        us: {
            HomeBackup: {
                fields: [
                    {
                        type: 'single',
                        id: '4423',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [9],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9625',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
            BatteryBackupForHome: {
                fields: [
                    {
                        type: 'single',
                        id: '4423',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [9],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9625',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
            CostSaving: {
                fields: [
                    {
                        type: 'single',
                        id: '4423',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [10],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9625',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
            RoadTrips: {
                fields: [
                    {
                        type: 'single',
                        id: '4423',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [11],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9625',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
            OffGrid: {
                fields: [
                    {
                        type: 'single',
                        id: '4423',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [12],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9625',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
            OutdoorRecreation: {
                fields: [
                    {
                        type: 'single',
                        id: '4423',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [13],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9625',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
        },
        ca: {
            HomeBackup: {
                fields: [
                    {
                        type: 'single',
                        id: '4424',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [9],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9626',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
            BatteryBackupForHome: {
                fields: [
                    {
                        type: 'single',
                        id: '4424',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [9],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9626',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
            CostSaving: {
                fields: [
                    {
                        type: 'single',
                        id: '4424',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [10],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9626',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
            RoadTrips: {
                fields: [
                    {
                        type: 'single',
                        id: '4424',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [11],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9626',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
            OffGrid: {
                fields: [
                    {
                        type: 'single',
                        id: '4424',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [12],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9626',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
            OutdoorRecreation: {
                fields: [
                    {
                        type: 'single',
                        id: '4424',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9435',
                        value: [13],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9626',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '1487185288',
                email: '',
            },
        },
        jp: {
            HomeBattery: {
                fields: [
                    {
                        type: 'single',
                        id: '4431',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9422',
                        value: [9],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9627',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '396526985',
                email: '',
            },
            Save: {
                fields: [
                    {
                        type: 'single',
                        id: '4431',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        type: 'single',
                        id: '31',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        type: 'multiple',
                        id: '9422',
                        value: [22],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: '9627',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
                source: 'WEB_NEW_PRODUCT_SUB',
                contactListId: '396526985',
                email: '',
            },
        },
    };

    const EMAIL_SUB_LINK: any = {
        us: {
            HomeBackup: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1372&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4423=1&inp_9435[]=9&inp_9625=${date}`,
            BatteryBackupForHome: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1372&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4423=1&inp_9435[]=9&inp_9625=${date}`,
            CostSaving: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1373&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4423=1&inp_9435[]=10&inp_9625=${date}`,
            RoadTrips: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1374&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4423=1&inp_9435[]=11&inp_9625=${date}`,
            OffGrid: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1375&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4423=1&inp_9435[]=12&inp_9625=${date}`,
            OutdoorRecreation: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1376&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4423=1&inp_9435[]=13&inp_9625=${date}`,
        },
        ca: {
            HomeBackup: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1377&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4424=1&inp_9435[]=9&inp_9626=${date}`,
            BatteryBackupForHome: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1377&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4424=1&inp_9435[]=9&inp_9626=${date}`,
            CostSaving: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1378&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4424=1&inp_9435[]=10&inp_9626=${date}`,
            RoadTrips: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1379&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4424=1&inp_9435[]=11&inp_9626=${date}`,
            OffGrid: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1380&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4424=1&inp_9435[]=12&inp_9626=${date}`,
            OutdoorRecreation: `https://media.ecoflow.com/u/register.php?CID=1049983726&f=1381&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4424=1&inp_9435[]=13&inp_9626=${date}`,
        },
        eu: {
            PowerIndependence:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1382&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4427=1&inp_9690[]=9',
            RoadTrips:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1383&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4427=1&inp_9690[]=10',
            OutdoorRecreation:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1384&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4427=1&inp_9690[]=11',
        },
        uk: {
            PowerIndependence:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1385&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4430=1&inp_9690[]=9',
            RoadTrips:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1386&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4430=1&inp_9690[]=10',
            OutdoorRecreation:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1387&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4430=1&inp_9690[]=11',
        },
        de: {
            PowerIndependence:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1391&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4425=1&inp_9690[]=9',
            RoadTrips:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1392&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4425=1&inp_9690[]=10',
            OutdoorRecreation:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1393&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4425=1&inp_9690[]=11',
        },
        fr: {
            PowerIndependence:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1388&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4428=1&inp_9690[]=9',
            RoadTrips:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1389&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4428=1&inp_9690[]=10',
            OutdoorRecreation:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1390&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4428=1&inp_9690[]=11',
        },
        it: {
            PowerIndependence:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1394&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4429=1&inp_9690[]=9',
            RoadTrips:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1395&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4429=1&inp_9690[]=10',
            OutdoorRecreation:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1396&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4429=1&inp_9690[]=11',
        },
        es: {
            PowerIndependence:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1397&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4426=1&inp_9690[]=9',
            RoadTrips:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1398&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4426=1&inp_9690[]=10',
            OutdoorRecreation:
                'https://media.ecoflow.com/u/register.php?CID=1046301189&f=1399&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4426=1&inp_9690[]=11',
        },
        jp: {
            HomeBattery:
                'https://media.ecoflow.com/u/register.php?CID=1047881588&f=1400&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4431=1&inp_9422[]=9',
            Vanlife:
                'https://media.ecoflow.com/u/register.php?CID=1047881588&f=1401&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4431=1&inp_9422[]=10',
            Camp: 'https://media.ecoflow.com/u/register.php?CID=1047881588&f=1402&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4431=1&inp_9422[]=11',
            Save: 'https://media.ecoflow.com/u/register.php?CID=396526985&f=1402&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4431=1&inp_9422[]=22',
        },
        kr: {
            RoadTrips:
                'https://media.ecoflow.com/u/register.php?CID=1047881588&f=1403&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4432=1&inp_9422[]=10',
            OutdoorRecreation:
                'https://media.ecoflow.com/u/register.php?CID=1047881588&f=1404&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4432=1&inp_9422[]=12',
            HomeBackup:
                'https://media.ecoflow.com/u/register.php?CID=1047881588&f=1405&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4432=1&inp_9422[]=9',
        },
        za: {
            LoadShedding:
                'https://media.ecoflow.com/u/register.php?CID=1045840001&f=1422&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4434=1&inp_9537[]=9',
            RoadTrips:
                'https://media.ecoflow.com/u/register.php?CID=1045840001&f=1423&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4434=1&inp_9537[]=10',
            OutdoorRecreation:
                'https://media.ecoflow.com/u/register.php?CID=1045840001&f=1424&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4434=1&inp_9537[]=11',
        },
        au: {
            HomeBackup:
                'https://media.ecoflow.com/u/register.php?CID=1045840001&f=1425&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4433=1&inp_9537[]=12',
            RoadTrips:
                'https://media.ecoflow.com/u/register.php?CID=1045840001&f=1426&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4433=1&inp_9537[]=10',
            OutdoorRecreation:
                'https://media.ecoflow.com/u/register.php?CID=1045840001&f=1427&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&inp_3=email&inp_4433=1&inp_9537[]=11',
        },
    };
    const LANG_TEXT = i18nText[locale]?.[pageType];
    const SUB_LINK = EMAIL_SUB_LINK[locale]?.[pageType];

    if (!LANG_TEXT || !SUB_LINK) return <></>;
    const prefixCls = 'ef-email-subscribe';
    const classString = classNames(prefixCls, styles.EmailSubscribe, className);
    const [status, setStatus] = useState('');
    const [email, setEmail] = useState('');
    const [checkbox, setCheckbox] = useState(false);

    const handleLink = (text: string) => {
        const link1 = `https://account.ecoflow.com/agreement/${i18nMap[locale]}/TermsOfUse.html`;
        const link2 = `https://account.ecoflow.com/agreement/${i18nMap[locale]}/PrivacyPolicy.html`;
        const regex1 = /<link1>(.*?)<\/link1>/;
        const regex2 = /<link2>(.*?)<\/link2>/;
        const match1 = text.match(regex1);
        let res = text;
        if (match1) {
            res = res.replace(regex1, `<a href='${link1}' target="_blank">${match1[1]}</a>`);
        }
        const match2 = text.match(regex2);
        if (match2) {
            res = res.replace(regex2, `<a href='${link2}' target="_blank">${match2[1]}</a>`);
        }
        return res;
    };

    const onSubmit = async () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: LANG_TEXT.btn,
            status: 'success',
            tag: 'Agree',
        });
        const jpPage = locale === 'jp' && (pathname === '/home-battery' || '/save-on-electric-bills');
        if (locale === 'us' || locale === 'ca' || jpPage) {
            const data = EMAIL_SUB_DATA[locale][pageType];
            data.email = email;
            const res: any = await sendMultiEmarsysEmail(
                locale,
                {
                    ...EMAIL_SUB_DATA[locale][pageType],
                },
                {
                    entry_position,
                    sector_name: LANG_TEXT.title,
                },
            );
            if (res?.code === '0') {
                setStatus('succ');
            }
            return;
        }
        setTimeout(() => {
            setStatus('succ');
        }, 1000);
    };

    const onCheck = (value: any) => setCheckbox(value.target.checked);
    const isJPHomeBattery = locale !== 'jp' && (pathname === '/home-battery' || '/save-on-electric-bills');
    return (
        <div className={classString}>
            <div className="wrapper">
                <div>
                    <p className="title" dangerouslySetInnerHTML={{ __html: LANG_TEXT.title }}></p>
                    <p className="subTitle" dangerouslySetInnerHTML={{ __html: LANG_TEXT.subTitle }}></p>
                </div>
                <div className="form">
                    <div className="email-input">
                        <input
                            type="text"
                            placeholder={LANG_TEXT.placeholder}
                            value={email}
                            onChange={(e) => {
                                const { value } = e.target;
                                const regx =
                                    /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
                                setStatus(value && !regx.test(value) ? 'error' : '');
                                setEmail(value.trim());
                            }}
                        />
                        {email && checkbox && !status ? (
                            isJPHomeBattery && locale !== 'us' && locale !== 'ca' ? (
                                <a className="btn" href={SUB_LINK.replace('email', email)} target="_brank" onClick={onSubmit}>
                                    {LANG_TEXT.btn}
                                </a>
                            ) : (
                                <span className="btn" onClick={onSubmit}>
                                    {LANG_TEXT.btn}
                                </span>
                            )
                        ) : (
                            <a className="btn disabled" target="_brank">
                                {LANG_TEXT.btn}
                            </a>
                        )}
                    </div>
                    <div className="tips">
                        <div className={`tips-succ ${status === 'succ' ? 'show' : ''}`}>{LANG_TEXT.tips_succ}</div>
                        <div className={`tips-error ${status === 'error' ? 'show' : ''}`}>
                            <Icon /> {LANG_TEXT.tips_error}
                        </div>
                        <div className={`tips-checked ${email && !checkbox && !status ? 'show' : ''}`}>{LANG_TEXT.tips_checked}</div>
                    </div>
                    <div className="checkbox">
                        <input type="checkbox" onClick={onCheck} />
                        <p className="text" dangerouslySetInnerHTML={{ __html: handleLink(LANG_TEXT.checkbox) }}></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailSubscribe;
